import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart, MessageCircle, Compass, Settings } from 'lucide-react';
import { useAuth, API } from '../App';
import axios from 'axios';

const BottomNav = () => {
  const location = useLocation();
  const { token } = useAuth();
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [newMatches, setNewMatches] = useState(0);

  // Fetch notification counts
  useEffect(() => {
    const fetchNotifications = async () => {
      if (!token) return;
      
      try {
        // Fetch unread message count
        const messagesRes = await axios.get(`${API}/messages`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const totalUnread = messagesRes.data.reduce((sum, conv) => sum + (conv.unread_count || 0), 0);
        setUnreadMessages(totalUnread);
        
        // Fetch new matches (matches from last 24 hours)
        const matchesRes = await axios.get(`${API}/matches`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);
        const recentMatches = matchesRes.data.filter(m => new Date(m.created_at) > oneDayAgo);
        setNewMatches(recentMatches.length);
      } catch (err) {
        // Silently fail
      }
    };

    fetchNotifications();
    
    // Poll every 30 seconds
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, [token, location.pathname]);

  const navItems = [
    { path: '/discover', icon: Compass, label: 'Opdag', badge: 0 },
    { path: '/matches', icon: Heart, label: 'Matches', badge: newMatches },
    { path: '/messages', icon: MessageCircle, label: 'Beskeder', badge: unreadMessages },
    { path: '/settings', icon: Settings, label: 'Indstillinger', badge: 0 }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-t border-border safe-area-inset-bottom">
      <div className="max-w-lg mx-auto px-4">
        <div className="flex items-center justify-around py-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`relative flex flex-col items-center py-2 px-4 rounded-xl transition-colors ${
                  isActive
                    ? 'text-primary'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <div className="relative">
                  <Icon className={`w-6 h-6 ${isActive ? 'fill-primary/20' : ''}`} />
                  {item.badge > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] flex items-center justify-center bg-primary text-white text-[10px] font-bold rounded-full px-1">
                      {item.badge > 99 ? '99+' : item.badge}
                    </span>
                  )}
                </div>
                <span className="text-[10px] mt-1 font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
